import { LatLng } from "leaflet";
import { useQuery } from "react-query";
import { getRasterData } from "../services/guppy.service";

export function useRasterData(layer: string | null, latLng: LatLng) {
  return useQuery<number | undefined, Error>(["rasterData", layer, latLng], () => getRasterData(layer, latLng), {
    retry: false,
  });
}
